import { usePostHog } from 'posthog-js/react';
import { useCallback } from 'react';

type DebounceableFunction<T extends unknown[]> = (...args: T) => void;

const debounce = <T extends unknown[]>(
  func: DebounceableFunction<T>,
  delay: number
): DebounceableFunction<T> => {
  let timeoutId: ReturnType<typeof setTimeout> | undefined;

  return function(this: unknown, ...args: T) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
};

export const useDebouncedPostHogCapture = () => {
  const posthog = usePostHog(); 

  const debouncedCapture = useCallback(
    debounce((eventName: string, properties?: Record<string, any>) => { 
      if (posthog) { 
        posthog.capture(eventName, properties);
      } else {
        console.warn('PostHog nao inicializado, evento nao capturado:', eventName);
      }
    }, 500),
    [posthog] 
  );

  return debouncedCapture;
};

